export function addQueryParam(urlString: string, param: string, value: any) {
  const absolute = urlString.search('://') > 0;
  const url = absolute
    ? new URL(urlString)
    : new URL(urlString, 'http://host');
  const searchParams = new URLSearchParams(url.search);
  searchParams.set(param, value);
  url.search = searchParams.toString();
  return absolute
    ? url.href
    : url.href.substring(11);
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/analytics/utils.ts